import React from 'react'
import { StyledHeading } from './styled'

const SectionHeading = ({ reverse, children }) => {
	return <StyledHeading reverse={reverse}>{children}</StyledHeading>
}

export default SectionHeading
